import React from "react";

import { Box, Typography } from "@mui/material";

interface IBlockquote {
  children: JSX.Element | JSX.Element[];
  bgcolor: string;
}

export const Blockquote = ({ children, bgcolor }: IBlockquote): JSX.Element => {
  return (
    <Box
      sx={{
        py: 1.75,
        px: 2,
        bgcolor: bgcolor
      }}>
      <Box
        sx={{
          maxWidth: { md: "1180px" },
          width: { md: "100%" },
          margin: { md: "0 auto" },
          display: "flex",
          justifyContent: { xs: "center", md: "flex-start" }
        }}>
        <Typography
          sx={{
            userSelect: "none",
            color: "white.main",
            position: "relative",
            top: -16,
            mr: 0.75,
            fontSize: { xs: 36, md: 96 }
          }}
          fontWeight={500}
          fontSize={36}>
          “
        </Typography>
        {children}
      </Box>
    </Box>
  );
};
